export class HashCalculator {
  static Calculate(text: string): number {
    let hash = 0;
    if (!text || text.length === 0) { return hash; }
    for (let i = 0; i < text.length; i++) {
      const chr = text.charCodeAt(i);
      hash  = ((hash << 5) - hash) + chr;
      hash |= 0;
    }
    return hash;
  }
}
